/**
 * Give - Stripe ACH Plaid Modal (Link).
 */

jQuery( document ).ready( function( $ ) {

	var donationButtonVal = $( '.give-submit-button-wrap input[type="submit"]' ).val();

	$( 'form[id^=give-form]' ).on( 'submit', async function( e ) {

		// Form that has been submitted.
		var donationForm = $( this ),
			formSubmit = $( this ).find( '.give-submit-button-wrap input[type="submit"]' ),
			chosenGateway = donationForm.find( 'input[name="give-gateway"]' ).val();

		// Check that Stripe is indeed the gateway chosen.
		if ( chosenGateway !== 'stripe_ach' ) {
			return;
		}

		// Ensure the Plaid modal displays above.
		donationForm.append( '<style>#plaid-link-iframe { z-index: 2147483541 !important; }</style>' );
		// Disable submit.
		formSubmit.prop( 'disabled', true );

		e.preventDefault();

		var linkHandler = Plaid.create( {
			token: await fetchLinkToken(),
			env: give_stripe_ach_vars.plaid_endpoint,
			apiVersion: give_stripe_ach_vars.plaid_api_version,
			selectAccount: true,
			onSuccess: function( public_token, metadata ) {
				// insert the token into the form so it gets submitted to the server
				donationForm.append( '<input type=\'hidden\' name=\'give_stripe_ach_token\' value=\'' + public_token + '\' />' );
				donationForm.append( '<input type=\'hidden\' name=\'give_stripe_ach_account_id\' value=\'' + metadata.account_id + '\' />' );
				// submit
				donationForm.get( 0 ).submit();
			},
			onExit: async function() {
				// Remove loading animations
				donationForm.find( '.give-loading-animation' ).hide();
				// Re-enable submit button.
				formSubmit.prop( 'disabled', false );
				// button and add back text.
				formSubmit.val( donationButtonVal );

				// Gracefully handle the invalid link token error. A link token
				// can become invalidated if it expires, has already been used
				// for a link session, or is associated with too many invalid logins.
				if ( err != null && err.error_code === 'INVALID_LINK_TOKEN' ) {
					linkHandler.destroy();
					linkHandler = Plaid.create( {
						...configs,
						token: await fetchLinkToken(),
					} );
				}
				if ( err != null ) {
					// Handle any other types of errors.
				}
				// metadata contains information about the institution that the
				// user selected and the most recent API request IDs.
				// Storing this information can be helpful for support.

			},
		} );

		linkHandler.open();

	} );

	const fetchLinkToken = async() => {
		const response = await fetch( give_global_vars.ajaxurl, {
			method: 'POST',
			credentials: 'same-origin',
			headers: new Headers( { 'Content-Type': 'application/x-www-form-urlencoded' } ),
			body: 'action=give_stripe_get_ach_link_token'
		} );

		const responseJSON = await response.json();

		return responseJSON.data.link_token;

	};

} );
